import Vue from "vue";

// Layout components
Vue.component("MasterLayout", require("@/layouts/Master.vue").default);
Vue.component("RawLayout", require("@/layouts/Raw.vue").default);
Vue.component("RegisterLayout", require("@/layouts/Register.vue").default);
